import { render, staticRenderFns } from "./ActivityComponent.vue?vue&type=template&id=18837b8e&scoped=true&"
import script from "./ActivityComponent.vue?vue&type=script&lang=js&"
export * from "./ActivityComponent.vue?vue&type=script&lang=js&"
import style0 from "./ActivityComponent.vue?vue&type=style&index=0&id=18837b8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18837b8e",
  null
  
)

export default component.exports